import { colors } from "@/shahrzad-assets/shared-constants/colors";
import { dimens } from "@/shahrzad-assets/shared-constants/dimens";
import { fontSize } from "@/shahrzad-assets/shared-constants/fonts";
import { FC } from "react";
import styled from "styled-components";

interface IProps {
    children: any
}

const ProfileImageContainer: FC<IProps> = ({children}) => {
    return ( 
        <ImagePlaceholeder>
            {children}
        </ImagePlaceholeder>
     );
}
 
export default ProfileImageContainer;

const ImagePlaceholeder = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3.75rem;
    aspect-ratio: 1;
    border-radius: ${dimens.BORDER_RADIUS_CIRCLE};
    font-size: ${fontSize.EXTRA_LARGE};
    color: ${colors.WHITE};
    background: var(
      --Gradient-Middle-Blue-Purple,
      linear-gradient(
        348deg,
        #9271bb 8.86%,
        rgba(146, 113, 187, 0.72) 50%,
        rgba(146, 113, 187, 0.48) 91.14%
      )
    );
`